import { render, staticRenderFns } from "./CreateTint.vue?vue&type=template&id=1fec0483&"
import script from "./CreateTint.vue?vue&type=script&lang=js&"
export * from "./CreateTint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports